<div class="access-denied-overlay">
  <div class="access-denied-content">
    <div class="modal-header">
      <h4 class="modal-title">Доступ заборонено</h4>
    </div>
    <div class="modal-body">
      <p>У вас немає прав для цієї дії.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="close()">Закрити</button>
    </div>
  </div>
</div>
